document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth <= 767;
  const sliders = document.querySelectorAll('.product-slider');

  sliders.forEach((slider) => {
    const swiper = new Swiper(slider, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      allowTouchMove: isMobile, // ✅ Enable dragging only on mobile

      scrollbar: {
        el: slider.querySelector('.swiper-progressbar'),
        hide: false, // show the bar always
        draggable: false, // optional
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      }
    });

    // ✅ Hide arrows on mobile
    if (isMobile) {
      const prevBtn = slider.querySelector('.swiper-button-prev');
      const nextBtn = slider.querySelector('.swiper-button-next');
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    // ✅ Match height to first image
    const firstImage = slider.querySelector('.swiper-slide img');
    if (firstImage) {
      const setSlideHeights = () => {
        const height = firstImage.clientHeight;
        slider.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.style.height = height + 'px';
        });
      };
      if (firstImage.complete) {
        setSlideHeights();
      } else {
        firstImage.addEventListener('load', setSlideHeights);
      }
    }
  });
});
